import type { ExperimentConfig } from './types'

export const STATIC_EXPERIMENTS: ExperimentConfig[] = []

export const STATIC_EXPERIMENT_CONFIG: Record<string, string> = {}
